import { colors } from "@zapalacorp/tokens";
import { FleetAvailability } from "Models/fleet.availability";
import { TFunction } from "react-i18next";

import { FleetAvailabilityStatus } from "./enums/fleet";

export const getStatusBadgeColorsByAvailability = (
  row: FleetAvailability,
  translate: TFunction<"translation", undefined>
): { color: string; background: string; label: string } => {
  const { status } = row;

  switch (status?.toLowerCase()) {
    case FleetAvailabilityStatus.IN_PROGRESS.toLowerCase():
      return {
        background: colors.warning50,
        color: colors.warning500,
        label: translate("inProgress"),
      };
    case FleetAvailabilityStatus.COMPLETED.toLowerCase():
      return {
        background: colors.success50,
        color: colors.success500,
        label: translate("completed"),
      };
    case FleetAvailabilityStatus.CANCELLED.toLowerCase():
      return {
        background: colors.error50,
        color: colors.error500,
        label: translate("cancelled"),
      };
    default:
      return {
        background: colors.brandBlue50,
        color: colors.brandBlue500,
        label: translate("pending"),
      };
  }
};
